module.exports = __webpack_public_path__ + "img/regular_1.4ddaca00.jpg";